<template>
  <div class="stand-query-list" v-loading="loading">
    <div class="list-main">
      <div class="from totalHeight list-form">
        <div class="btn-wrap">
          <OmsForm :form-config="searchFormConfig" />
          <div class="operation">
            <div class="btn">
              <OmsButton :btn-config="filterBtnConfig" />
            </div>
          </div>
        </div>
      </div>
      <div class="list-table">
        <div class="tableBox" v-loading="agTableConfig.agLoading">
          <OmsAgTable
            ref="agGridChild"
            :options="options"
            :ag-table-config="agTableConfig"
            @on-page-change="pageChange"
            @on-page-size-change="pageSizeChange"
            @on-selection-change="onSelectionChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setFormDataFunMixin } from '@/assets/js/mixins/setFormData';

export default {
  name: 'StandQueryList',
  mixins: [setFormDataFunMixin],
  props: {
    table: {
      type: String,
      default: '',
    },
    tableId: {
      type: [String, Number],
      default: '',
    },
    selectable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      tableName: '',
      pageDesc: '',
      webConf: {},
      selection: [],
      options: {
        datas: {},
        status4css: [],
      },
      searchFormConfig: {
        formData: [],
        formValue: {},
        formValueName: {},
        ruleValidate: {},
        isGrid: true,
      },
      filterBtnConfig: {
        buttons: [
          {
            text: '查找',
            type: 'primary',
            icon: 'md-search',
            btnclick: () => {
              this.agTableConfig.pagenation.current = 1;
              this.getList();
            },
          },
          {
            text: '重置',
            icon: 'md-refresh',
            btnclick: () => {
              this.resetForm();
            },
          },
        ],
      },
      agTableConfig: {
        isIndex: true,
        agLoading: false,
        columnDefs: [],
        rowData: [],
        pageShow: true,
        pageInline: true,
        tableHeight: '300px',
        pagenation: {
          total: 0,
          pageSize: 30,
          current: 1,
          pageSizeOpts: [10, 20, 30, 50, 100, 200, 500],
        },
      },
    };
  },
  watch: {
    table: {
      handler(val) {
        if (val) {
          this.tableName = val;
          this.getTableQuery();
        }
      },
      immediate: true,
    },
  },
  methods: {
    normalizeSearchField(item) {
      const field = {
        ...item,
        name: item.coldesc || item.name,
        display: item.display || 'text',
      };
      if (field.display === 'OBJ_FK' && field.fkobj) {
        const { fkobj } = field;
        const fkdisplay = fkobj.searchmodel || 'drp';
        field.isfk = true;
        field.fkdisplay = fkdisplay;
        field.reftable = fkobj.reftable;
        field.reftableid = fkobj.reftableid;
        if (fkdisplay === 'mrp') {
          field.multiple = true;
          field.pid = [];
        }
      } else if (field.display === 'OBJ_SELECT' && field.combobox) {
        field.display = 'select';
        field.multiple = true;
        field.filterable = true;
      } else if (field.display === 'OBJ_DATENUMBER' && field.daterange) {
        field.dateType = 'daterange';
        field.dateFormat = 'yyyy-MM-dd';
        field.defval = this.buildDateRangeDefault(field.daterange);
      }
      return field;
    },
    buildDateRangeDefault(days) {
      const rangeDays = Number(days) || 0;
      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(endDate.getDate() - rangeDays);
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
      return [formatDate(startDate), formatDate(endDate)];
    },
    parseSelectDefaultValue(defaultRaw) {
      if (defaultRaw === undefined || defaultRaw === null || defaultRaw === '') return [];
      if (Array.isArray(defaultRaw)) {
        return defaultRaw.map((v) => this.resolveSelectOptionValue(v)).filter((v) => v !== '' && v !== null && v !== undefined);
      }
      return String(defaultRaw).split(',').map((s) => s.trim()).filter(Boolean);
    },
    patchSearchFormSelectFields(formList = []) {
      const defaultMap = {};
      (formList || []).forEach((field) => {
        if (!field || !field.colname) return;
        if (field.default === undefined || field.default === null || field.default === '') return;
        defaultMap[field.colname] = field.default;
      });
      (this.searchFormConfig.formData || []).forEach((item) => {
        if (item.style !== 'select') return;
        const colname = item.colname || item.value;
        if (!colname) return;
        const initVal = this.parseSelectDefaultValue(defaultMap[colname]);
        if (defaultMap[colname] !== undefined) {
          item.default = defaultMap[colname];
        }
        this.$set(this.searchFormConfig.formValue, colname, initVal);
        const options = item.options || [];
        if (initVal.length) {
          this.$set(this.searchFormConfig.formValueName, colname, this.buildSelectDisplayLabels(initVal, options));
        }
        const originSelectChange = item.selectChange;
        item.selectChange = (val) => {
          const labels = this.buildSelectDisplayLabels(val, options);
          this.$set(this.searchFormConfig.formValueName, colname, labels);
          if (typeof originSelectChange === 'function') {
            originSelectChange(val);
          }
        };
      });
    },
    patchSearchFormDateFields(formList = []) {
      (formList || []).forEach((field) => {
        if (!field || field.display !== 'OBJ_DATENUMBER' || !field.daterange) return;
        const colname = field.colname;
        const formItem = (this.searchFormConfig.formData || []).find(
          (item) => (item.value || item.colname) === colname,
        );
        if (!formItem) return;
        formItem.type = 'daterange';
        formItem.format = 'yyyy-MM-dd';
        formItem.vModelFormat = true;
        formItem.isDateRange = true;
        formItem.defaultRange = field.daterange;
        this.$set(this.searchFormConfig.formValue, colname, this.buildDateRangeDefault(field.daterange));
      });
    },
    buildSelectDisplayLabels(val, options = []) {
      if (val === '' || val === null || val === undefined) return '';
      const list = Array.isArray(val) ? val : [val];
      return list.map((v) => this.resolveSelectOptionLabel(v, options)).filter(Boolean).join(',');
    },
    resolveSelectOptionValue(v) {
      if (v && typeof v === 'object') {
        if (v.value !== undefined) return v.value;
        if (v.limitval !== undefined) return v.limitval;
        if (v.val !== undefined) return v.val;
      }
      return v;
    },
    resolveSelectOptionLabel(v, combobox = []) {
      if (v && typeof v === 'object') {
        if (v.label) return v.label;
        if (v.Label) return v.Label;
        if (v.limitdesc) return v.limitdesc;
        if (v.value !== undefined) v = v.value;
        else if (v.limitval !== undefined) v = v.limitval;
        else if (v.val !== undefined) v = v.val;
      }
      const raw = String(v).replace('=', '');
      if (!raw) return '';
      const opt = combobox.find((o) => o.value == raw || o.limitval == raw);
      return opt ? (opt.label || opt.limitdesc) : raw;
    },
    getSearchFormItem(key) {
      return (this.searchFormConfig.formData || []).find(
        (item) => (item.value || item.colname) === key,
      );
    },
    formatDateNumber(val) {
      if (val === '' || val === null || val === undefined) return '';
      if (val instanceof Date && !Number.isNaN(val.getTime())) {
        const year = val.getFullYear();
        const month = String(val.getMonth() + 1).padStart(2, '0');
        const day = String(val.getDate()).padStart(2, '0');
        return `${year}${month}${day}`;
      }
      const str = String(val).trim();
      if (!str) return '';
      if (/^\d{8}$/.test(str)) return str;
      const digits = str.replace(/\D/g, '');
      return digits.length >= 8 ? digits.slice(0, 8) : '';
    },
    formatSearchDateRange(values = []) {
      const range = values.map((v) => this.formatDateNumber(v)).filter(Boolean);
      if (!range.length) return '';
      return range.join('~');
    },
    calcTableHeight() {
      this.$nextTick(() => {
        const listMain = this.$el && this.$el.querySelector('.list-main');
        if (!listMain) return;
        const listForm = this.$el.querySelector('.list-form');
        let topHeight = 0;
        if (listForm) topHeight += listForm.offsetHeight;
        const height = Math.max(listMain.clientHeight - topHeight - 45, 120);
        // this.agTableConfig.tableHeight = `${height}px`;
      });
    },
    getTableQuery() {
      const formData = new FormData();
      formData.append('table', this.tableName);
      formData.append('getcmd', 'y');
      this.loading = true;
      this.service.common.getTableQuery(formData).then((res) => {
        if (res.data.code === 0) {
          const { datas, tabcmd } = res.data;
          this.pageDesc = (tabcmd && tabcmd.desc) || this.pageDesc;
          this.webConf = datas.webconf || {};
          if (datas.status4css) {
            this.options.status4css = datas.status4css;
          }
          const formList = (datas.dataarry || []).map((item) => this.normalizeSearchField(item));
          this.formCommonFun('searchFormConfig', formList, 6);
          this.searchFormConfig.isGrid = true;
          this.$nextTick(() => {
            this.$nextTick(() => {
              this.patchSearchFormSelectFields(formList);
              this.patchSearchFormDateFields(formList);
              this.getList();
            });
          });
        }
      }).finally(() => {
        this.loading = false;
        this.calcTableHeight();
      });
    },
    getSearchParams() {
      const { pagenation } = this.agTableConfig;
      const searchdata = {
        table: this.tableName,
        startindex: (pagenation.current - 1) * pagenation.pageSize,
        range: pagenation.pageSize,
        fixedcolumns: {},
        column_include_uicontroller: true,
        isolr: false,
      };
      const val = this.searchFormConfig.formValue || {};
      Object.keys(val).forEach((key) => {
        const itemVal = val[key];
        if (itemVal === '' || itemVal === null || itemVal === undefined) {
          return;
        }
        if (typeof itemVal === 'boolean') {
          searchdata.fixedcolumns[key] = itemVal ? 'Y' : 'N';
        } else if (Array.isArray(itemVal)) {
          const formItem = this.getSearchFormItem(key);
          if (formItem && formItem.style === 'date' && (formItem.isDateRange || formItem.type === 'daterange')) {
            const rangeValue = this.formatSearchDateRange(itemVal);
            if (!rangeValue) return;
            searchdata.fixedcolumns[key] = rangeValue;
            return;
          }
          const hasValue = itemVal.some((v) => {
            if (v === '' || v === null || v === undefined) return false;
            if (typeof v === 'string') return v.trim() !== '';
            return true;
          });
          if (!hasValue) return;
          searchdata.fixedcolumns[key] = itemVal;
        } else if (typeof itemVal === 'string' && itemVal.trim() !== '') {
          searchdata.fixedcolumns[key] = itemVal.trim();
        }
      });
      return searchdata;
    },
    getList() {
      this.selection = [];
      this.agTableConfig.agLoading = true;
      const params = new FormData();
      params.append('searchdata', JSON.stringify(this.getSearchParams()));
      this.service.common.QueryList(params).then(({ data: res }) => {
        if (res.code === 0) {
          const data = res.datas || {};
          const { tabth, row, totalRowCount, defaultrange, selectrange } = data;
          if (defaultrange) {
            this.agTableConfig.pagenation.pageSize = defaultrange;
          }
          if (selectrange && selectrange.length) {
            this.agTableConfig.pagenation.pageSizeOpts = selectrange;
          }
          this.agTableConfig.columnDefs = (tabth || []).map((item) => ({
            ...item,
            thAlign: 'center',
            tdAlign: item.type === 'NUMBER' ? 'right' : 'left',
          }));
          if (this.selectable && this.agTableConfig.columnDefs.length) {
            this.agTableConfig.columnDefs[0] = {
              ...this.agTableConfig.columnDefs[0],
              checkboxSelection: true,
              headerCheckboxSelection: true,
            };
          }
          this.agTableConfig.rowData = row || [];
          this.agTableConfig.pagenation.total = totalRowCount || 0;
        } else {
          this.agTableConfig.rowData = [];
          this.agTableConfig.pagenation.total = 0;
          this.$Message.error(res.message || '查询失败');
        }
      }).finally(() => {
        this.agTableConfig.agLoading = false;
        this.calcTableHeight();
      });
    },
    resetForm() {
      (this.searchFormConfig.formData || []).forEach((item) => {
        const key = item.value || (item.itemdata && item.itemdata.colname);
        if (!key) return;
        if (item.style === 'checkbox') {
          this.$set(this.searchFormConfig.formValue, key, false);
          this.$set(this.searchFormConfig.formValueName, key, '');
        } else if (item.style === 'date' && item.defaultRange) {
          this.$set(this.searchFormConfig.formValue, key, this.buildDateRangeDefault(item.defaultRange));
        } else if (item.style === 'select' && item.multiple) {
          const initVal = this.parseSelectDefaultValue(item.default);
          this.$set(this.searchFormConfig.formValue, key, initVal);
          this.$set(
            this.searchFormConfig.formValueName,
            key,
            initVal.length ? this.buildSelectDisplayLabels(initVal, item.options || []) : '',
          );
        } else if (item.style === 'dropSelect' && item.itemdata && item.itemdata.fkdisplay === 'mrp') {
          this.$set(this.searchFormConfig.formValue, key, []);
          this.$set(this.searchFormConfig.formValueName, key, '');
        } else {
          this.$set(this.searchFormConfig.formValue, key, '');
          this.$set(this.searchFormConfig.formValueName, key, '');
        }
      });
      this.agTableConfig.pagenation.current = 1;
      this.getList();
    },
    pageChange(val) {
      this.agTableConfig.pagenation.current = val;
      this.getList();
    },
    pageSizeChange(val) {
      this.agTableConfig.pagenation.pageSize = val;
      this.agTableConfig.pagenation.current = 1;
      this.getList();
    },
    getRowId(row) {
      return row.ID && row.ID.val !== undefined ? row.ID.val : row.ID;
    },
    flattenRows(rows = []) {
      return rows.map((item) => {
        const row = { ...item };
        Object.keys(row).forEach((key) => {
          if (row[key] && row[key].val !== undefined) {
            row[key] = row[key].val;
          }
        });
        return row;
      });
    },
    onSelectionChange(selection) {
      this.selection = selection || [];
      this.$emit('selection-change', this.getSelection());
    },
    getSelection() {
      return this.flattenRows(this.selection);
    },
  },
};
</script>

<style lang="less" scoped>
.stand-query-list {
  height: 100%;

  .list-main {
    height: 100%;
  }

  .list-form {
    .btn-wrap {
      flex-direction: column;

      .business-form-main {
        border: none;
        padding-bottom: 0;
        /deep/ #dropMultiSelectFilter {
          font-size: 0;
          .ark-fkrp-select-icon {
            top: 4px;
          }
          .ark-input[disabled] {
            color: inherit;
          }
        }

        /deep/ .cusForm-content {
          max-height: 174px;
          overflow-y: auto;
        }

        /deep/ .ark-form-item.popSelect {
          .ark-select-selection-head {
            font-size: 0;
          }
        }
      }

      /deep/ .button-combina .button-content {
        justify-content: end;
      }

      .btn {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }
}
</style>
